import { render, staticRenderFns } from "./PaymentPstnListForm.vue?vue&type=template&id=b03eb28c&lang=pug"
import script from "./PaymentPstnListForm.vue?vue&type=script&lang=js"
export * from "./PaymentPstnListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports